/*
 * ArchiveIndex Messages
 *
 * This contains all the text for the ArchiveIndex component.
 */
import { defineMessages } from 'react-intl';

export default defineMessages({
  title: {
    id: 'app.containers.ArchivePage.title',
    defaultMessage: 'Archive',
  },
  intro: {
    id: 'app.components.ArchiveIndex.intro',
    defaultMessage: 'Archived groups remain available for a while before they are finaly removed. You cannot post new messages or comments.',
  },
  empty: {
    id: 'app.components.ArchiveIndex.empty',
    defaultMessage: 'You have no archived groups',
  },
  description: {
    id: 'app.containers.ArchivePage.description',
    defaultMessage: 'List of archived groups',
  },
});
